import { Avatar } from '@mui/material';
import React from 'react';

export const ExamAvatar = ({ icon }: { icon: string }) => {
  const [src, setSrc] = React.useState(`/static/images/exams/${icon}.png`);
  return (
    <Avatar
      className='row-avatar'
      sx={{ height: 24, width: 24 }}
      src={src}
      slotProps={{
        img: {
          onError: () => setSrc(`/static/images/exams/${icon}.svg`), // Some icons have not been visually updated, and are in the old SVG format.
        },
      }}
    />
  );
};
